import { IAsSeenOnSectionProps } from "./AsSeenOnSection.types";
import "./AsSeenOnSection.scss";

export default function AsSeenOnSection(props: IAsSeenOnSectionProps) {
  const logos = [
    { name: "Herald Sun", src: "/images/herald-sun.png" },
    { name: "2GB Sydney", src: "/images/2gb.png" },
    { name: "The Advertiser", src: "/images/the-advertiser.png" },
    { name: "The West Australian", src: "/images/the-west-australian.png" },
    { name: "Channel 9", src: "/images/channel9.png" },
    { name: "Yahoo Finance", src: "/images/yahoo-finance.png" },
    { name: "Sunrise", src: "/images/sunrise.png" },
    { name: "Mum Central", src: "/images/mum-central.png" },
    { name: "ABC Radio", src: "/images/abc-radio.png" },
    { name: "7 News", src: "/images/7news.png" },
    { name: "Dog Lover", src: "/images/dog-lover.png" },
    { name: "Today", src: "/images/today.png" },
  ];
  return (
    <div  data-testid="AsSeenOnSection" className="box-as-seen-on-section">
      <hr />
      <div className="as-seen-on-section">
        <div className="section-title">As Seen on:</div>
        <div className="content">
          <div className="brand-info">
            <img
              src="/images/logo-petsy-pet-insurance.png"
              alt="Logo Petsy Pet Insurance"
            />
            <p className="brand-description">
              As seen on TV, <br /> in newspapers & heard on radio
            </p>
          </div>
          <div className="separator">
            <hr />
          </div>
          <div className="logo-grid">
            {logos.map((logo) => (
              <img
                key={logo.name}
                src={logo.src}
                alt={logo.name}
                className="logo-item"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
